import { connect } from "react-redux";
import { Dispatch } from "react";
import actions from "../redux/actions/Index";
import MetricsPage from "../components/pages/metrics/MetricsPage";
import { ICreateUpdateMetrics, IGetQueryParams } from "interfaces/Index";

export const mapStateToProps = (state: any) => {
  const { metrics, zone } = state;
  return {
    isLoading: metrics.isLoading,
    isError: metrics.isError,
    error: metrics.error,
    isMetricsUpdated: metrics.isMetricsUpdated,
    metricsDetailsFetched: metrics.metricsDetailsFetched,
    isMetricsDetailsFetched: metrics.isMetricsDetailsFetched,
    citiesList: zone.citiesList,
    isCityListFetched: zone.isCityListFetched,
    isCoreMetricsFetched: metrics.isCoreMetricsFetched,
    coreMetricsFetched: state.metrics.coreMetricsFetched,
    isCategoriesMetricsFetched: metrics.isCategoriesMetricsFetched,
    categoriesMetrics: metrics.categoriesMetrics,
    isMetricsUploading: metrics.isMetricsUploading,
    isMetricsUploaded: metrics.isMetricsUploaded,
    isMetricsUploadingError: metrics.isMetricsUploadingError,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    updateMetrics: (metricsPayload: ICreateUpdateMetrics) =>
      dispatch(actions.createUpdateMetrics(metricsPayload)),
    fetchCities: () => dispatch(actions.fetchCities()),
    getMetrics: (id: string) => dispatch(actions.getMetricsDetailsAction(id)),
    getAllCoreMetrics: (queryPrams?: IGetQueryParams) =>
      dispatch(actions.getAllCoreMetricsAction(queryPrams)),
    getCategoriesForMetrics: (id: string) =>
      dispatch(actions.CategoriesForMetricsAction(id)),
    metricsUpload: (payload: FormData, queryPrams?: IGetQueryParams) =>
      dispatch(actions.metricsUpload(payload, queryPrams)),
  };
};

const MetricsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(MetricsPage);

export default MetricsContainer;
